module.exports = __webpack_public_path__ + "img/品質管理3-11.6d0e1761.png";